import type {
  ClipboardEventHandler,
  CompositionEventHandler,
  ReactElement,
  RefObject,
} from 'react';
import { createContext, type KeyboardEvent } from 'react';
import type { Editor } from 'slate';
import type { RenderElementProps, RenderLeafProps } from 'slate-react';
import type { MentionContextProps } from '../components/mention/types';

export interface EditableProps {
  editableRef: RefObject<HTMLDivElement | null>;
  renderLeaf: (props: RenderLeafProps) => ReactElement;
  renderElement: (props: RenderElementProps) => ReactElement;
  onKeyDown: (event: KeyboardEvent<HTMLDivElement>) => void;
  onPaste: ClipboardEventHandler<HTMLDivElement>;
  onCompositionStart: CompositionEventHandler<HTMLDivElement>;
  onCompositionEnd: CompositionEventHandler<HTMLDivElement>;
}

export interface EditorContextValue {
  editor: Editor;
  editableProps: EditableProps;
  mention?: MentionContextProps;
}

export const editorContext = createContext<EditorContextValue>({} as never);

export function useEditorContext() {
  return useContext(editorContext);
}
